<template>
  <tbody>
    <tr class="perm-group-row" @click="$emit('toggle', group.groupName)">
      <td :colspan="colSpan">
        <div class="d-flex align-items-center">
          <span class="sub-group-indent"></span>
          <v-icon small class="mr-2">mdi-{{ isCollapsed ? 'chevron-up' : 'chevron-down' }}</v-icon>
          <span class="sub-group-name">{{ group.groupName }}</span>
        </div>
      </td>
    </tr>
    <template v-if="!isCollapsed">
      <PermissionRow
        v-for="item in group.items"
        :key="item.id"
        :item="item"
        :visible-role-ids="visibleRoleIds"
        :role-color-map="roleColorMap"
        @role-change="$emit('role-change', $event)"
      />
    </template>
  </tbody>
</template>

<script>
import PermissionRow from './PermissionRow.vue';

export default {
  name: 'PermissionGroup',
  components: { PermissionRow },
  props: {
    group: { type: Object, required: true },
    parentMenuGroup: { type: String, default: '' },
    isCollapsed: { type: Boolean, default: false },
    colSpan: { type: Number, default: 1 },
    visibleRoleIds: { type: Set, required: true },
    roleColorMap: { type: Map, required: true },
  },
};
</script>

<style lang="scss" scoped>
.perm-group-row {
  background: #f8f9fc;
  cursor: pointer;
  user-select: none;

  td {
    padding: 6px 12px;
    font-size: 13px;
    border-bottom: 1px solid #e4e6ef;
  }

  &:hover td {
    background: #eef0f8;
  }
}

.sub-group-indent {
  width: 20px;
  display: inline-block;
}

.sub-group-name {
  font-weight: 600;
  color: #5e6278;
  font-size: 13px;
}
</style>
